import r, { OPTIONS as w } from "../managers/braze-instance.js";
import na from "./push-manager.js";
var ra = {
  l: !1,
  aa: null,
  ea: function ea() {
    return ra.p(), ra.aa || (ra.aa = new na(r.mr(), r.Ma(), r.ue(), r.Z(), r.ee(w._a), r.ee(w.Aa), r.ee(w.Ba), r.v(), r.ee(w.Ca), r.ee(w.Da), r.j())), ra.aa;
  },
  p: function p() {
    ra.l || (r.h(ra), ra.l = !0);
  },
  destroy: function destroy() {
    ra.aa = null, ra.l = !1;
  }
};
export default ra;